import React, { useState } from 'react';
import '../../../../styles/globals.css'
import { Box, Divider } from '@mui/material'
import karmaStyles from '../../../../styles/KarmaPool.module.css'

function AdminDashboardMenuHeaderComponent(props) {
    return (
        <>
            <Box sx={{ paddingTop : "0.5rem", fontSize : "1.2rem" }}>
                <p> <strong> ⚡ Karma Pool ⚡</strong></p>
            </Box>
            <Box sx={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "0.25rem" }}>
                <Divider variant='middle' sx={{ bgcolor: "rgba(221, 221, 221, 0.875)", width: "45%", minWidth : "15rem" }} />
            </Box>
            <p className={karmaStyles.homepageDescription}>

                <a href={"/karma/dashboard/admin"}>
                    {props.homeEnabled ? <strong>home</strong> : "home"}
                </a>
                {" / "}
                <a href={"/karma/dashboard/admin/pool"}>
                    {props.poolEnabled ? <strong>pool</strong> : "pool"}
                </a>
                {" / "}
                <a href={"/karma/dashboard/admin/cycles"}>
                    {props.cycleEnabled ? <strong>cycles</strong> : "cycles"}
                </a>
                {" / "}
                <a href={"/karma/dashboard/admin/causes"}>
                    {props.causesEnabled ? <strong>causes</strong> : "causes"}
                </a>
                {" / "}
                <a href={"/karma/dashboard/admin/users"}>
                    {props.usersEnabled ? <strong>users</strong> : "users"}
                </a>
                {" / "}
                <a href={"/karma/dashboard/admin/registration"}>
                    {props.registrationCodesEnabled ? <strong>registration-codes</strong> : "registration-codes"}
                </a>
                {" / "}
                <a href={"/karma/dashboard/admin/newsletter"}>
                    {props.newsletterEnabled ? <strong>newsletter</strong> : "newsletter"}
                </a>
            </p>
            <Box sx={{ width: "100%", display: "flex", justifyContent: "center", marginBottom: "1.5rem" }}>
                <Divider variant='middle' sx={{ bgcolor: "rgba(221, 221, 221, 0.875)", width: "45%", minWidth : "15rem" }} />
            </Box>
        </>
    );

}

export default AdminDashboardMenuHeaderComponent;